export default "__VITE_ASSET__CQ8ygE1G__"